import React, { useState } from "react";

import Select, { components } from "react-select";

import { ReactComponent as DropdownArrowDown } from "../../../assets/icons/dropdownArrowDown.svg";
import { ReactComponent as DropdownArrowUp } from "../../../assets/icons/dropdownArrowUp.svg";

import Calendar from "../../../assets/icons/biCalendar.svg";

import moment from "moment";
import CalendarComponent from "../../common/Calendar/Calendar";
import { typeOfPAF } from "../../../constants/typeOfPAF";

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <DropdownArrowUp />
        ) : (
          <DropdownArrowDown />
        )}
      </components.DropdownIndicator>
    )
  );
};

const DigitalPAF = ({
  handleChange,
  registerPatient,
  personalDetails,
  handleChangeCheckBox,
  validateFields,
  updateRegisterPatient,
  showErrors,
  handleChangeSelect,
  indications,
  capsulePerCycle,
  numberOfCycles,
  isPharmacy,
  parseLocalStorage,
  isRenewal,
}) => {
  const [isHighTechOpen, setIsHighTechOpen] = useState(false);
  const [isDobOpen, setIsDobOpen] = useState(false);
  const [isPregnancyOpen, setIsPregnancyOpen] = useState(false);
  const [isDateOfPAFOpen, setIsDateOfPAFOpen] = useState(false);
  const [isDatPregnanacyTestOpen, setIsDatPregnanacyTestOpen] = useState(false);

  const isMale = registerPatient.patient_type === 0;
  const isWCBP = registerPatient.patient_type === 1;

  const parseTitle = isMale ? "Male" : isWCBP ? "WCBP" : "WNCBP";

  var today = new Date();

  const setDateComponentOpen = (event, setToBeOpened, toBeOpened) => {
    event.preventDefault();
    if (toBeOpened) {
      setToBeOpened(false);
    } else {
      setIsHighTechOpen(false);
      setIsDobOpen(false);
      setIsPregnancyOpen(false);
      setIsDateOfPAFOpen(false);
      setIsDatPregnanacyTestOpen(false);
      setToBeOpened(true);
    }
  };

  return (
    <div>
      <h1 className="select-category-txt">
        {isPharmacy
          ? "Converting to a Digital Prescription Authorization Form"
          : `Prescription Authorization Form - ${
              !isRenewal ? parseTitle : `Renewal for ${parseTitle}`
            }`}
      </h1>

      <hr className="green-hr" />

      <div className="m-top-3 m-bot-3 min-height">
        {isPharmacy ? (
          <React.Fragment>
            <div className="ml-14">
              <b className="font-size-16">
                How to create a digital PAF from a paper PAF.
              </b>
            </div>
            <ol>
              <li className="pt-3 font-size-16">
                Ensure that you have received a completed paper Prescription
                Authorisation Form (PAF) from a registered physician.
              </li>
              <li className="pt-3 font-size-16">
                To generate a digital PAF, copy the information from the paper
                Prescription Authorization Form into the fields below.
              </li>
              <li className="pt-3 font-size-16">
                When the digital PAF has been generated, it will be possible to
                complete the Order Form and request delivery of the medication
                from the distributor.
              </li>
              <li className="pt-3 font-size-16">
                Pharmacy must retain the paper PAF.
              </li>
            </ol>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {registerPatient.patient_type === typeOfPAF.WOMANOFCP ? (
              <ol>
                <li className="font-size-16">
                  {isRenewal
                    ? "Cetain fields in the PAF renewal are auto-populated for your convenience."
                    : "Enter the full hospital name and address where the patient is treated."}
                </li>
                <li className="pt-3 font-size-16">
                  {isRenewal
                    ? "Select the appropriate strength and quantity of individual capsules required for this prescription. The maximum quantity allowable for this patient is a 4 week supply."
                    : "Enter the indication and drug name"}
                </li>
                <li className="pt-3 font-size-16">
                  {isRenewal
                    ? "Enter the most recent negative pregnancy test date."
                    : "Select the appropriate strength and quantity of individual capsules required for this prescription. The maximum quantity allowable for this patient is a 4 week supply."}
                </li>
                <li className="pt-3 font-size-16">
                  {isRenewal
                    ? "Please ensure that steps 2-3 are complete and all auto-populated information is correct."
                    : "Enter the most recent negative pregnancy test date."}
                </li>
              </ol>
            ) : (
              <ol>
                <li className="font-size-16">
                  {isRenewal
                    ? "Certain fields in the PAF renewal are auto-populated for your convenience"
                    : "Enter the full hospital name and address where the patient is treated."}
                </li>
                <li className="pt-3 font-size-16">
                  {isRenewal
                    ? "Select the appropriate strength and quantity of individual capsules required for this prescription. The maximum quantity allowable for this patient is a 12 week supply 3."
                    : "Enter the indication and drug name."}
                </li>
                <li className="pt-3 font-size-16">
                  {isRenewal
                    ? "Please ensure step 2 is complete and all auto-populated information is correct."
                    : "Select the appropriate strength and quantity of individual capsules required for this prescription. The maximum quantity allowable for this patient is a 12 week supply."}
                </li>
              </ol>
            )}
          </React.Fragment>
        )}

        {!isPharmacy ? (
          <React.Fragment>
            <h2 className="title-details">Patient Details</h2>
            <div className="container">
              <div className="row">
                <div className="col">
                  <label className="silver">Patient Category</label>
                  <input
                    type="text"
                    name="patient_category"
                    value={
                      registerPatient.patient_type === typeOfPAF.MALE
                        ? "Male"
                        : registerPatient.patient_type === typeOfPAF.WOMANOFNCP
                        ? "Woman of Non-Childbearing Potential"
                        : "Woman of Childbearing Potential"
                    }
                    className="silver"
                    disabled
                  />
                </div>
                <div className="col">
                  <label
                    className={
                      showErrors &&
                      (!validateFields?.high_tech_prescription_date?.isValid ||
                        (isRenewal &&
                          !validateFields?.high_tech_prescription_date_interval
                            ?.isValid))
                        ? "red-label"
                        : ""
                    }
                  >
                    High Tech Prescription Date:*
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="high_tech_prescription_date"
                        name="high_tech_prescription_date"
                        className={
                          "transparent-background " +
                          (showErrors &&
                          (!validateFields?.high_tech_prescription_date
                            ?.isValid ||
                            (isRenewal &&
                              !validateFields
                                ?.high_tech_prescription_date_interval
                                ?.isValid))
                            ? "error"
                            : "")
                        }
                        value={
                          registerPatient.high_tech_prescription_date
                            ? moment(
                                registerPatient.high_tech_prescription_date
                              ).format("DD / MM / YYYY")
                            : ""
                        }
                        placeholder="DD / MM / YYYY"
                        onClick={(e) => {
                          setDateComponentOpen(
                            e,
                            setIsHighTechOpen,
                            isHighTechOpen
                          );
                        }}
                        readOnly
                      />
                      <img src={Calendar} alt="Calendar" className="calendar" />
                    </div>
                    {isHighTechOpen && (
                      <div
                        className="container--div"
                        style={{
                          alignItems: "center",
                          right: "41px",
                        }}
                      >
                        <div className="react-arrow-div" />
                        <CalendarComponent
                          close={setIsHighTechOpen}
                          setDateRaw={(date) => {
                            updateRegisterPatient(
                              "patient_pregnancy_test",
                              null
                            );
                            updateRegisterPatient(
                              "high_tech_prescription_date",
                              date
                            );
                          }}
                          date={registerPatient.high_tech_prescription_date}
                          type="high_tech_prescription_date"
                          selectRange={false}
                          minDate={
                            registerPatient.patient_type === typeOfPAF.WOMANOFCP
                              ? moment().subtract(1, "w").toDate()
                              : moment().subtract(12, "w").toDate()
                          }
                          maxDate={today}
                        />
                      </div>
                    )}
                    {showErrors &&
                      (!validateFields?.high_tech_prescription_date?.isValid ? (
                        <span className="required-text">Required</span>
                      ) : (
                        isRenewal &&
                        !validateFields?.high_tech_prescription_date_interval
                          ?.isValid && (
                          <span className="required-text">
                            Date cannot be 7 days before date of PAF
                          </span>
                        )
                      ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label
                    className={
                      showErrors && !validateFields?.patient_initial?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Patient Initials:*
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="patient_initial"
                    value={registerPatient.patient_initial || ""}
                    placeholder="Initials"
                    className={
                      showErrors && !validateFields?.patient_initial?.isValid
                        ? "error"
                        : ""
                    }
                    maxLength="3"
                    readOnly={isRenewal}
                  />

                  {showErrors && !validateFields?.patient_initial?.isValid && (
                    <span className="required-text">Required</span>
                  )}
                </div>

                {!isWCBP ? (
                  <div className="col">
                    <label
                      className={
                        showErrors && !validateFields?.patient_dob?.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Patient Date of Birth:*
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      {!isRenewal ? (
                        <div style={{ width: "100%" }}>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            id="patient_dob"
                            name="patient_dob"
                            className={
                              "transparent-background " +
                              (showErrors &&
                              !validateFields?.patient_dob?.isValid
                                ? "error"
                                : "")
                            }
                            value={
                              registerPatient.patient_dob
                                ? moment(registerPatient.patient_dob).format(
                                    "DD / MM / YYYY"
                                  )
                                : ""
                            }
                            placeholder="DD / MM / YYYY"
                            onClick={(e) => {
                              setDateComponentOpen(e, setIsDobOpen, isDobOpen);
                            }}
                            readOnly
                          />
                          <img
                            src={Calendar}
                            alt="Calendar"
                            className="calendar"
                          />
                        </div>
                      ) : (
                        <div style={{ width: "100%" }}>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            value={
                              registerPatient.patient_dob
                                ? moment(registerPatient.patient_dob).format(
                                    "DD / MM / YYYY"
                                  )
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      )}
                      {isDobOpen && (
                        <div
                          className="container--div"
                          style={{
                            alignItems: "center",
                            right: "41px",
                          }}
                        >
                          <div className="react-arrow-div" />
                          <CalendarComponent
                            close={setIsDobOpen}
                            setDateRaw={(date) =>
                              updateRegisterPatient("patient_dob", date)
                            }
                            date={registerPatient.patient_dob}
                            type="DOB"
                            selectRange={false}
                            maxDate={today}
                          />
                        </div>
                      )}
                      {showErrors && !validateFields?.patient_dob?.isValid && (
                        <span className="required-text">Required</span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="col">
                    <label
                      className={
                        showErrors &&
                        !validateFields?.patient_pregnancy_test?.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Date of Last Negative Pregnancy Test:*
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <input
                          style={{ width: "100%" }}
                          type="text"
                          id="patient_pregnancy_test"
                          name="patient_pregnancy_test"
                          className={
                            "transparent-background " +
                            (showErrors &&
                            !validateFields?.patient_pregnancy_test?.isValid
                              ? "error"
                              : "")
                          }
                          value={
                            registerPatient.patient_pregnancy_test
                              ? moment(
                                  registerPatient.patient_pregnancy_test
                                ).format("DD / MM / YYYY")
                              : ""
                          }
                          placeholder="DD / MM / YYYY"
                          onClick={(e) => {
                            setDateComponentOpen(
                              e,
                              setIsPregnancyOpen,
                              isPregnancyOpen
                            );
                          }}
                          readOnly
                        />
                        <img
                          src={Calendar}
                          alt="Calendar"
                          className="calendar"
                        />
                      </div>
                      {isPregnancyOpen && (
                        <div
                          className="container--div"
                          style={{
                            alignItems: "center",
                            right: "41px",
                          }}
                        >
                          <div className="react-arrow-div" />
                          <CalendarComponent
                            close={setIsPregnancyOpen}
                            setDateRaw={(date) =>
                              updateRegisterPatient(
                                "patient_pregnancy_test",
                                date
                              )
                            }
                            date={registerPatient.patient_pregnancy_test}
                            type="patient_pregnancy_test"
                            maxDate={
                              registerPatient?.high_tech_prescription_date ??
                              today
                            }
                          />
                        </div>
                      )}
                      {showErrors &&
                        !validateFields?.patient_pregnancy_test?.isValid && (
                          <span className="required-text">Required</span>
                        )}
                    </div>
                  </div>
                )}
              </div>
              {isWCBP && (
                <div className="row">
                  <div className="col">
                    <label
                      className={
                        showErrors && !validateFields?.patient_dob?.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Patient Date of Birth:*
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      {!isRenewal ? (
                        <div style={{ width: "100%" }}>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            id="patient_dob"
                            name="patient_dob"
                            className={
                              "transparent-background " +
                              (showErrors &&
                              !validateFields?.patient_dob?.isValid
                                ? "error"
                                : "")
                            }
                            value={
                              registerPatient.patient_dob
                                ? moment(registerPatient.patient_dob).format(
                                    "DD / MM / YYYY"
                                  )
                                : ""
                            }
                            placeholder="DD / MM / YYYY"
                            onClick={(e) => {
                              setDateComponentOpen(e, setIsDobOpen, isDobOpen);
                            }}
                            readOnly
                          />
                          <img
                            src={Calendar}
                            alt="Calendar"
                            className="calendar"
                          />
                        </div>
                      ) : (
                        <div style={{ width: "100%" }}>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            value={
                              registerPatient.patient_dob
                                ? moment(registerPatient.patient_dob).format(
                                    "DD / MM / YYYY"
                                  )
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      )}
                      {isDobOpen && (
                        <div
                          className="container--div"
                          style={{
                            alignItems: "center",
                            right: "41px",
                          }}
                        >
                          <div className="react-arrow-div" />
                          <CalendarComponent
                            close={setIsDobOpen}
                            setDateRaw={(date) =>
                              updateRegisterPatient("patient_dob", date)
                            }
                            date={registerPatient.patient_dob}
                            type="DOB"
                            selectRange={false}
                            maxDate={today}
                          />
                        </div>
                      )}
                      {showErrors && !validateFields?.patient_dob?.isValid && (
                        <span className="required-text">Required</span>
                      )}
                    </div>
                  </div>
                  <div className={"col"} />
                </div>
              )}
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="container pt-3">
              <div className="row">
                <div className="col">
                  <label
                    className={
                      showErrors && !validateFields?.prescriber_name?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Prescriber name:*
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="prescriber_name"
                    value={registerPatient.prescriber_name || ""}
                    maxLength={30}
                    className={
                      showErrors && !validateFields?.prescriber_name?.isValid
                        ? "error"
                        : ""
                    }
                    placeholder="Name"
                  />

                  {showErrors && !validateFields?.prescriber_name?.isValid && (
                    <span className="required-text">Required</span>
                  )}
                </div>
                <div className="col">
                  <label
                    className={
                      showErrors &&
                      !validateFields?.name_and_address_hospital?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Name and Address of treating Hospital:*
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="name_and_address_hospital"
                    value={registerPatient?.name_and_address_hospital || ""}
                    placeholder="Address"
                    maxLength={50}
                    className={
                      showErrors &&
                      !validateFields?.name_and_address_hospital?.isValid
                        ? "error"
                        : ""
                    }
                  />
                  {showErrors &&
                    !validateFields?.name_and_address_hospital?.isValid && (
                      <span className="required-text">Required</span>
                    )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label
                    className={
                      showErrors &&
                      !validateFields?.high_tech_prescription_date?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Date of High Tech Prescription:*
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="high_tech_prescription_date"
                        name="high_tech_prescription_date"
                        className={
                          "transparent-background " +
                          (showErrors &&
                          !validateFields?.high_tech_prescription_date?.isValid
                            ? "error"
                            : "")
                        }
                        value={
                          registerPatient.high_tech_prescription_date
                            ? moment(
                                registerPatient.high_tech_prescription_date
                              ).format("DD / MM / YYYY")
                            : ""
                        }
                        placeholder="DD / MM / YYYY"
                        onClick={(e) => {
                          setDateComponentOpen(
                            e,
                            setIsHighTechOpen,
                            isHighTechOpen
                          );
                        }}
                        readOnly
                      />
                      <img src={Calendar} alt="Calendar" className="calendar" />
                    </div>
                    {isHighTechOpen && (
                      <div
                        className="container--div"
                        style={{
                          alignItems: "center",
                          right: "41px",
                        }}
                      >
                        <div className="react-arrow-div" />
                        <CalendarComponent
                          close={setIsHighTechOpen}
                          setDateRaw={(date) => {
                            updateRegisterPatient(
                              "patient_pregnancy_test",
                              null
                            );
                            updateRegisterPatient(
                              "high_tech_prescription_date",
                              date
                            );
                          }}
                          date={registerPatient.high_tech_prescription_date}
                          type="high_tech_prescription_date"
                          selectRange={false}
                          maxDate={today}
                          minDate={
                            registerPatient.patient_type === typeOfPAF.WOMANOFCP
                              ? moment().subtract(1, "w").toDate()
                              : moment().subtract(12, "w").toDate()
                          }
                        />
                      </div>
                    )}
                    {showErrors &&
                      !validateFields?.high_tech_prescription_date?.isValid && (
                        <span className="required-text">Required</span>
                      )}
                  </div>
                </div>
                <div className="col">
                  <label
                    className={
                      showErrors && !validateFields?.date_paper_paf?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Date of Paper PAF*:
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="date_paper_paf"
                        name="date_paper_paf"
                        className={
                          "transparent-background " +
                          (showErrors &&
                          !validateFields?.date_paper_paf?.isValid
                            ? "error"
                            : "")
                        }
                        value={
                          registerPatient.date_paper_paf
                            ? moment(registerPatient.date_paper_paf).format(
                                "DD / MM / YYYY"
                              )
                            : ""
                        }
                        placeholder="DD / MM / YYYY"
                        onClick={(e) => {
                          setDateComponentOpen(
                            e,
                            setIsDateOfPAFOpen,
                            isDateOfPAFOpen
                          );
                        }}
                        readOnly
                      />
                      <img src={Calendar} alt="Calendar" className="calendar" />
                    </div>
                    {isDateOfPAFOpen && (
                      <div
                        className="container--div"
                        style={{
                          alignItems: "center",
                          right: "41px",
                        }}
                      >
                        <div className="react-arrow-div" />
                        <CalendarComponent
                          close={setIsDateOfPAFOpen}
                          setDateRaw={(date) =>
                            updateRegisterPatient("date_paper_paf", date)
                          }
                          date={registerPatient.date_paper_paf}
                          type="date_paper_paf"
                          selectRange={false}
                          maxDate={today}
                        />
                      </div>
                    )}
                    {showErrors && !validateFields?.date_paper_paf?.isValid && (
                      <span className="required-text">Required</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <h2 className="title-details">Patient Details</h2>
            <div className="container pt-3">
              <div className="row">
                <div className="col">
                  <label className="silver">Patient category:</label>
                  <input
                    type="text"
                    name="patient_category"
                    value={
                      registerPatient.patient_type === typeOfPAF.MALE
                        ? "Male"
                        : registerPatient.patient_type === typeOfPAF.WOMANOFNCP
                        ? "Woman of Non-Childbearing Potential"
                        : "Woman of Childbearing Potential"
                    }
                    className="silver"
                    disabled
                  />
                </div>
                {registerPatient.patient_type !== typeOfPAF.WOMANOFCP ? (
                  <div className="col"></div>
                ) : (
                  <div className="col">
                    <label
                      className={
                        showErrors &&
                        !validateFields?.patient_pregnancy_test?.isValid
                          ? "red-label"
                          : ""
                      }
                    >
                      Date of Last Negative Pregnancy Test:*
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <input
                          style={{ width: "100%" }}
                          type="text"
                          id="patient_pregnancy_test"
                          name="patient_pregnancy_test"
                          className={
                            "transparent-background " +
                            (showErrors &&
                            !validateFields?.patient_pregnancy_test?.isValid
                              ? "error"
                              : "")
                          }
                          value={
                            registerPatient.patient_pregnancy_test
                              ? moment(
                                  registerPatient.patient_pregnancy_test
                                ).format("DD / MM / YYYY")
                              : ""
                          }
                          onClick={(e) => {
                            setDateComponentOpen(
                              e,
                              setIsDatPregnanacyTestOpen,
                              isDatPregnanacyTestOpen
                            );
                          }}
                          placeholder="DD / MM / YYYY"
                          readOnly
                        />
                        <img
                          src={Calendar}
                          alt="Calendar"
                          className="calendar"
                        />
                      </div>
                      {isDatPregnanacyTestOpen && (
                        <div
                          className="container--div"
                          style={{
                            alignItems: "center",
                            right: "41px",
                          }}
                        >
                          <div className="react-arrow-div" />
                          <CalendarComponent
                            close={setIsDatPregnanacyTestOpen}
                            setDateRaw={(date) => {
                              updateRegisterPatient(
                                "patient_pregnancy_test",
                                date
                              );
                            }}
                            date={registerPatient.patient_pregnancy_test}
                            type="patient_pregnancy_test"
                            maxDate={
                              registerPatient?.high_tech_prescription_date ??
                              today
                            }
                          />
                        </div>
                      )}
                      {showErrors &&
                        !validateFields?.patient_pregnancy_test?.isValid && (
                          <span className="required-text">Required</span>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="container pt-3">
              <div className="row">
                <div className="col">
                  <label
                    className={
                      showErrors && !validateFields?.patient_initial?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Patient Initials:*
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="patient_initial"
                    value={registerPatient.patient_initial || ""}
                    className={
                      showErrors && !validateFields?.patient_initial?.isValid
                        ? "error"
                        : ""
                    }
                    placeholder="Initials"
                    maxLength="3"
                  />

                  {showErrors && !validateFields?.patient_initial?.isValid && (
                    <span className="required-text">Required</span>
                  )}
                </div>
                <div className="col">
                  <label
                    className={
                      showErrors && !validateFields?.patient_dob?.isValid
                        ? "red-label"
                        : ""
                    }
                  >
                    Patient Date of birth:*
                  </label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="patient_dob"
                        name="patient_dob"
                        className={
                          "transparent-background " +
                          (showErrors && !validateFields?.patient_dob?.isValid
                            ? "error"
                            : "")
                        }
                        value={
                          registerPatient.patient_dob
                            ? moment(registerPatient.patient_dob).format(
                                "DD / MM / YYYY"
                              )
                            : ""
                        }
                        placeholder="DD / MM / YYYY"
                        onClick={(e) => {
                          setDateComponentOpen(e, setIsDobOpen, isDobOpen);
                        }}
                        readOnly
                      />
                      <img src={Calendar} alt="Calendar" className="calendar" />
                    </div>
                    {isDobOpen && (
                      <div
                        className="container--div"
                        style={{
                          alignItems: "center",
                          right: "41px",
                        }}
                      >
                        <div className="react-arrow-div" />
                        <CalendarComponent
                          close={setIsDobOpen}
                          setDateRaw={(date) =>
                            updateRegisterPatient("patient_dob", date)
                          }
                          date={registerPatient.patient_dob}
                          type="DOB"
                          selectRange={false}
                          maxDate={today}
                        />
                      </div>
                    )}
                    {showErrors && !validateFields?.patient_dob?.isValid && (
                      <span className="required-text">Required</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}

        <h2 className="title-details">Prescription Details</h2>

        <div className="container">
          {!isPharmacy && (
            <div className="row">
              <div className="col">
                <label
                  className={
                    showErrors &&
                    !validateFields?.name_and_address_hospital?.isValid
                      ? "red-label"
                      : ""
                  }
                >
                  Name and Address of treating Hospital:
                </label>
                {!isRenewal ? (
                  <input
                    type="text"
                    name="name_and_address_hospital"
                    value={
                      parseLocalStorage?.hospital?.name +
                      ", " +
                      parseLocalStorage?.hospital?.address?.full_address
                    }
                    placeholder="Hospital Name and Address"
                    className={"silver"}
                    disabled
                  />
                ) : (
                  <input
                    type="text"
                    name="name_and_address_hospital"
                    value={
                      parseLocalStorage?.hospital?.name +
                        parseLocalStorage?.hospital?.address?.full_address ??
                      registerPatient.name_and_address_hospital
                    }
                    placeholder="Hospital Name and Address"
                    className={"silver"}
                    disabled
                  />
                )}
              </div>
            </div>
          )}

          <div className="row mb-3 paf-renew-custom">
            <div className="col">
              <label
                className={
                  showErrors && !validateFields?.indication?.isValid
                    ? "red-label"
                    : ""
                }
              >
                Indication:*{" "}
              </label>
              {!isRenewal ? (
                <Select
                  classNamePrefix="custom-select"
                  components={{
                    DropdownIndicator: DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  value={registerPatient.indication}
                  onChange={(selectedOption) => {
                    handleChangeSelect(selectedOption, "indication");
                  }}
                  options={indications}
                  placeholder="Select"
                  className={
                    showErrors && !validateFields?.indication?.isValid
                      ? "error-border"
                      : ""
                  }
                />
              ) : (
                <div className="col">
                  <input
                    type="text"
                    value={registerPatient?.indication?.label || ""}
                    readOnly
                  />
                </div>
              )}
              {showErrors && !validateFields?.indication?.isValid && (
                <span className="required-text">Required</span>
              )}
            </div>
            <div className="col">
              <label>Molecule:</label>
              <input
                type="text"
                value="Lenalidomide"
                className="gray"
                disabled
              />
            </div>
          </div>
          <div className="row">
            {registerPatient.indication?.value === 0 && (
              <div className="row mb-3">
                <div className="col col-sm-6-custom">
                  <label>Other indication:*</label>

                  <input
                    type="text"
                    onChange={(e) => handleChange(e)}
                    name="indication_other"
                    value={registerPatient.indication_other || ""}
                    placeholder="Other indication"
                    maxLength={75}
                    readOnly={isRenewal}
                  />
                  {showErrors && !validateFields?.indication_other?.isValid && (
                    <span className="required-text">Required</span>
                  )}
                </div>
                <div className="col col-sm-6-custom"></div>
              </div>
            )}
          </div>
          <div className="row mb-3 paf-renew-custom">
            <div className="col">
              <label>Capsule Strength:*</label>
              <i className="italic-min"></i>
              <input
                type="text"
                onChange={handleChange}
                name="capsules_strenght_5"
                value="5 mg"
                className="mb-5"
                disabled
              />
            </div>
            <div className="col">
              <label
                className={
                  showErrors && !validateFields?.capsule_per_cycle?.isValid
                    ? "red-label"
                    : ""
                }
              >
                Capsules per Cycle:*
              </label>
              <i className="italic-min">(Not pack size)</i>
              <Select
                classNamePrefix="margin-custom-select custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={registerPatient.capsule_per_cycle_5}
                onChange={(selectedOption) => {
                  handleChangeSelect(selectedOption, "capsule_per_cycle_5");
                }}
                options={capsulePerCycle}
                placeholder="Select"
              />
            </div>
            {registerPatient.patient_type === typeOfPAF.WOMANOFCP ? (
              <div className="col">
                <label>Number of Cycles:</label>
                <input value="1 Cycle" className="mb-5 gray" disabled />
              </div>
            ) : (
              <div className="col">
                <label
                  className={
                    showErrors && !validateFields?.number_cycles?.isValid
                      ? "red-label"
                      : ""
                  }
                >
                  Number of Cycles:*
                </label>
                <i className="italic-min"></i>
                <Select
                  classNamePrefix="margin-custom-select custom-select"
                  components={{
                    DropdownIndicator: DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  value={registerPatient.number_cycles}
                  onChange={(selectedOption) => {
                    handleChangeSelect(selectedOption, "number_cycles");
                  }}
                  options={numberOfCycles}
                  placeholder="Select"
                  className={
                    showErrors && !validateFields?.number_cycles?.isValid
                      ? "error-border"
                      : ""
                  }
                />
                {showErrors && !validateFields?.number_cycles?.isValid && (
                  <span className="required-text">Required</span>
                )}
              </div>
            )}
            <div className="col">
              <label>Total Capsules:</label>
              <input
                type="text"
                onChange={handleChange}
                name="capsules_strenght_5"
                value={registerPatient.total_capsules || ""}
                className="mb-5"
                placeholder="No Total"
                disabled
              />
            </div>
          </div>

          {registerPatient.capsule_per_cycle_5?.value === 0 && (
            <div className="row mb-3">
              <div className="col"></div>
              <div className="col">
                <label>Other Capsules per Cycle:*</label>

                <input
                  type="number"
                  onChange={(e) => handleChange(e)}
                  name="capsule_cycle_other_5"
                  value={registerPatient.capsule_cycle_other_5 || ""}
                  placeholder="Other Capsules per Cycle"
                  min="1"
                />
                {showErrors &&
                  !validateFields?.capsule_cycle_other_5?.isValid && (
                    <span className="required-text">Required</span>
                  )}
              </div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
          )}

          <div className="row mb-3 paf-renew-custom">
            <div className="col">
              <input
                type="text"
                onChange={handleChange}
                name="capsules_strenght_10"
                value="10 mg"
                disabled
              />
            </div>
            <div className="col">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={registerPatient.capsule_per_cycle_10}
                onChange={(selectedOption) => {
                  handleChangeSelect(selectedOption, "capsule_per_cycle_10");
                }}
                options={capsulePerCycle}
                placeholder="Select"
              />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
          {registerPatient.capsule_per_cycle_10?.value === 0 && (
            <div className="row mb-3">
              <div className="col"></div>
              <div className="col">
                <label>Other Capsules per Cycle:*</label>

                <input
                  type="number"
                  onChange={(e) => handleChange(e)}
                  name="capsule_cycle_other_10"
                  value={registerPatient.capsule_cycle_other_10 || ""}
                  placeholder="Other Capsules per Cycle"
                  min="1"
                />
                {showErrors &&
                  !validateFields?.capsule_cycle_other_10?.isValid && (
                    <span className="required-text">Required</span>
                  )}
              </div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
          )}
          <div className="row mb-3 paf-renew-custom">
            <div className="col">
              <input
                type="text"
                onChange={handleChange}
                name="capsules_strenght_15"
                value="15 mg"
                disabled
              />
            </div>
            <div className="col">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={registerPatient.capsule_per_cycle_15}
                onChange={(selectedOption) => {
                  handleChangeSelect(selectedOption, "capsule_per_cycle_15");
                }}
                options={capsulePerCycle}
                placeholder="Select"
              />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
          {registerPatient.capsule_per_cycle_15?.value === 0 && (
            <div className="row mb-3">
              <div className="col"></div>
              <div className="col">
                <label>Other Capsules per Cycle:*</label>

                <input
                  type="number"
                  onChange={(e) => handleChange(e)}
                  name="capsule_cycle_other_15"
                  value={registerPatient.capsule_cycle_other_15 || ""}
                  placeholder="Other Capsules per Cycle"
                  min="1"
                />
                {showErrors &&
                  !validateFields?.capsule_cycle_other_15?.isValid && (
                    <span className="required-text">Required</span>
                  )}
              </div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
          )}
          <div className="row mb-3 paf-renew-custom">
            <div className="col">
              <input
                type="text"
                onChange={handleChange}
                name="capsules_strenght_20"
                value="20 mg"
                disabled
              />
            </div>
            <div className="col">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={registerPatient.capsule_per_cycle_20}
                onChange={(selectedOption) => {
                  handleChangeSelect(selectedOption, "capsule_per_cycle_20");
                }}
                options={capsulePerCycle}
                placeholder="Select"
              />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
          {registerPatient.capsule_per_cycle_20?.value === 0 && (
            <div className="row mb-3">
              <div className="col"></div>
              <div className="col">
                <label>Other Capsules per Cycle:*</label>

                <input
                  type="number"
                  onChange={(e) => handleChange(e)}
                  name="capsule_cycle_other_20"
                  value={registerPatient.capsule_cycle_other_20 || ""}
                  placeholder="Other Capsules per Cycle"
                  min="1"
                />
                {showErrors &&
                  !validateFields?.capsule_cycle_other_20?.isValid && (
                    <span className="required-text">Required</span>
                  )}
              </div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
          )}
          <div className="row mb-3 paf-renew-custom">
            <div className="col">
              <input
                type="text"
                onChange={handleChange}
                name="capsules_strenght_25"
                value="25 mg"
                disabled
              />
            </div>
            <div className="col">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={registerPatient.capsule_per_cycle_25}
                onChange={(selectedOption) => {
                  handleChangeSelect(selectedOption, "capsule_per_cycle_25");
                }}
                options={capsulePerCycle}
                placeholder="Select"
              />
            </div>
            <div className="col"></div>
            <div className="col"></div>
          </div>
          {registerPatient.capsule_per_cycle_25?.value === 0 && (
            <div className="row mb-3">
              <div className="col"></div>
              <div className="col">
                <label>Other Capsules per Cycle:*</label>

                <input
                  type="number"
                  onChange={(e) => handleChange(e)}
                  name="capsule_cycle_other_25"
                  value={registerPatient.capsule_cycle_other_25 || ""}
                  placeholder="Other Capsules per Cycle"
                  min="1"
                />
                {showErrors &&
                  !validateFields?.capsule_cycle_other_25?.isValid && (
                    <span className="required-text">Required</span>
                  )}
              </div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
          )}

          {!isPharmacy && isWCBP ? (
            <div>
              <label
                htmlFor="confirmation_has_been_conselled"
                className={
                  "custom-checkbox font-size-16 dove-gray " +
                  (showErrors &&
                  !validateFields?.confirmation_has_been_conselled?.isValid
                    ? "red-label"
                    : "")
                }
              >
                The patient has been counselled about the teratogenic risk of
                treatment and the need to avoid pregnancy, and has been on
                effective contraception for at least 4 weeks or committed to
                absolute and continuous abstinence confirmed on a monthly
                basis*.
                <input
                  type="checkbox"
                  id="confirmation_has_been_conselled"
                  name="confirmation_has_been_conselled"
                  checked={
                    registerPatient.confirmation_has_been_conselled || false
                  }
                  onChange={handleChangeCheckBox}
                />
                <span className="checkmark" />
              </label>
            </div>
          ) : (
            !isPharmacy &&
            isMale && (
              <div>
                <label
                  htmlFor="confirmation_has_been_conselled"
                  className={
                    "custom-checkbox font-size-16 dove-gray " +
                    (showErrors &&
                    !validateFields?.confirmation_has_been_conselled?.isValid
                      ? "red-label"
                      : "")
                  }
                >
                  The patient has been counselled about the teratogenic risk of
                  treatment with lenalidomide and understands the need to use a
                  condom if involved in sexual activity with a woman of
                  childbearing potential not using effective contraception or if
                  their partner is pregnant (even if the patient has had a
                  vasectomy)*.
                  <input
                    type="checkbox"
                    id="confirmation_has_been_conselled"
                    name="confirmation_has_been_conselled"
                    checked={
                      registerPatient.confirmation_has_been_conselled || false
                    }
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            )
          )}

          {isPharmacy && (
            <React.Fragment>
              <div>
                <label
                  htmlFor="confirmation_other1"
                  className={
                    "custom-checkbox font-size-16 dove-gray font-size-16 " +
                    (showErrors && !validateFields?.confirmation_other1?.isValid
                      ? "red-label"
                      : "")
                  }
                >
                  The prescriber has confirmed that he/she has provided the
                  appropriate counselling to the patient as per the appropriate
                  patient category*
                  <input
                    type="checkbox"
                    id="confirmation_other1"
                    name="confirmation_other1"
                    checked={registerPatient.confirmation_other1 || false}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>
              </div>
              <div>
                <label
                  htmlFor="confirmation_other2"
                  className={
                    "custom-checkbox font-size-16 dove-gray font-size-16 " +
                    (showErrors && !validateFields?.confirmation_other2?.isValid
                      ? "red-label"
                      : "")
                  }
                >
                  I confirm that the prescriber has signed the Prescriber`s
                  declaration*
                  <input
                    type="checkbox"
                    id="confirmation_other2"
                    name="confirmation_other2"
                    checked={registerPatient.confirmation_other2 || false}
                    onChange={handleChangeCheckBox}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            </React.Fragment>
          )}
        </div>

        {isPharmacy ? (
          <h2 className="title-details">Pharmacist Declaration:</h2>
        ) : (
          <h2 className="title-details gray">Prescriber Declaration:</h2>
        )}
        <div className="container initiation">
          <div className="row">
            <div className="col">
              <label className="aqua-deep">
                {isPharmacy ? "Pharmacist Name" : "Prescriber Name"}
              </label>
              <input
                type="text"
                className="disabled"
                name="prescriberName"
                value={
                  personalDetails?.full_name ||
                  personalDetails?.first_name + " " + personalDetails?.last_name
                }
                disabled
              />
            </div>
            <div className="col">
              <label className="aqua-deep">
                {isPharmacy ? "Date" : "Date of PAF"}
              </label>
              <input
                className="transparent-background disabled"
                value={moment().format("DD / MM / YYYY")}
                disabled
              />

              <img src={Calendar} alt="Calendar" className="calendar" />
            </div>
          </div>
        </div>

        <div>
          <label
            htmlFor="confirmation_other3"
            className={
              "custom-checkbox bold dove-gray font-size-18 " +
              (showErrors && !validateFields?.confirmation_other3?.isValid
                ? "red-label"
                : "")
            }
          >
            {isPharmacy
              ? "For women of childbearing potential, dispensing will be taking place within 7 days of the date of prescription. I am dispensing no more than 4 weeks supply to women of childbearing potential and 12 weeks for males and women of non-childbearing potential*"
              : "I confirm that I am a physician experienced in managing haematological malignancy and I have read and understood the Healthcare Professional's Information Guide and confirm that the patient has signed a treatment initiation form*"}

            <input
              type="checkbox"
              id="confirmation_other3"
              name="confirmation_other3"
              checked={registerPatient.confirmation_other3 || false}
              onChange={handleChangeCheckBox}
            />
            <span className="checkmark" />
          </label>
        </div>
      </div>
    </div>
  );
};
export default DigitalPAF;
